import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "../Style.css";
import PartnerListWithPayoutChecker from "./PartnerlistWithPayoutChecker"
import { Button, Checkbox, Radio, Badge, Segmented, message } from "antd";
import { use } from "react";
import { payoutDataWithPartner } from "../helper/payoutdatasample";
import { connect } from "react-redux";
import Logout from "../../../containers/Pages/Login/Logout";
import { useNavigate, useParams } from "react-router-dom";
import { payoutApprovalStagesSuccess } from "../../../redux/PayoutApprovalStages/action";
import { getMonthlySummarySuccess, payoutPartnerDataSearch, payoutPartnerDataSuccess } from "../../../redux/PayoutPartnerData/action";
import useSession from "../../CustomLogout/useSession";
import { Card } from "antd";
import { CloseCircleOutlined, HighlightTwoTone, LeftCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { getPayoutQueryInternalActionv2, getRaisePayoutQueryInternalAction } from "../../../redux/PayoutQueryInternal/Action";
import { Input } from "antd";
import { debounce, set } from "lodash";

const PartnerListDetailsChecker = (props) => {
  const [landatasource, setLanDatasource] = useState([]);
  const [searchlandatasource, setSearchLanDatasource] = useState([]);
  const [payoutStagesData, setPayoutStagesData] = useState([]);
  const [makerAction, setMakerAction] = useState(false);
  const [checkerAction, setCheckerAction] = useState(false);
  const [searchTextTable, setSearchTextTable] = useState("");
  const [utrAction, setUtrAction] = useState(false);
  const [radiostate, setRadioState] = useState("All");
  const [currentStage, setCurrentStage] = useState(null);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({ Check: [] });
  const [payoutPartnerData, setPayoutPartnerData] = useState([]);
  const { monthlyReportId } = useParams();
  const [summaryData, setSummaryData] = useState([]);
  const [multiQueryReamark, setMultiQueryRemark] = useState([]);
  const handleSessionExpired = useSession();
  const [downloading, setDownloading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const navigate = useNavigate();

  // const [navItem, setNavItem] = useState([]);


  useEffect(() => {
    handleRadioChange(radiostate, payoutPartnerData.content);

  }, [monthlyReportId, radiostate]);


  useEffect(() => {
    fetchPayoutStagesData();
  }, [monthlyReportId, props.payoutApprovalStagesSuccess]);

  useEffect(() => {
    fetchMonthlySummary();
  }, [monthlyReportId]);




  //fetch Monthly summary report

  const fetchMonthlySummary = async (reportid = monthlyReportId) => {
    try {

      const summaryResponse = await props.getMonthlySummary({
        accessToken: props.accessToken,
        reportId: reportid
      });
      const data = await summaryResponse;
      const errorCode = data?.response?.data?.error?.errorCode || data.errorCode;
      const errorMessage = data?.response?.data?.error?.errorMessage || data.errorMessage;
      if (errorCode === "403" && (data?.response?.data?.error?.logoutStatus || data?.data?.error?.logoutStatus)) {
        // Handle logout status
        handleSessionExpired();
        return;
      }
      setSummaryData(data || []);
      return data;
    } catch (error) {
      setSummaryData([]);
      return (error)
    }
  }


  const fetchPayoutStagesData = async () => {
    // Simulating an API call to fetch payout stages data 
    setDownloading(true);
    try {
      const payoutStagesResponse = props.payoutApprovalStagesSuccess({
        accessToken: props.accessToken,
        reportId: monthlyReportId,
      })

      const payoutStagesData = await payoutStagesResponse || [];
      const errorCode = payoutStagesData?.response?.data?.error?.errorCode || payoutStagesData.errorCode;
      const errorMessage = payoutStagesData?.response?.data?.error?.errorMessage || payoutStagesData.errorMessage;
      if (errorCode === "403" && (payoutStagesData?.data?.error?.logoutStatus || payoutStagesData?.response?.data?.error?.logoutStatus)) {
        // Handle logout status
        console.error("Logout status detected, redirecting to login page.");
        // You can redirect to the login page or show a message
        handleSessionExpired();
        return;
      }

      setPayoutStagesData(payoutStagesData);
    } catch (error) {
      console.error("Error fetching payout stages data:", error);
    } finally {
      setDownloading(false);
    }

  };


  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  const handleStageMap = {
    0: "All",
    1: "PendingwithCETMaker",
    2: "PendingwithCETChecker",
    3: "PendingwithCPChecker",
    4: "CpApproved",
    5: "PendingwithPartner",
    6: "PartnerQuery",
    7: "InvoiceUploaded",
    8: "CETApprovalPendingonInvoice",
    9: "CpapprovalpendingonInvoice",
    10: "CpApprovedInvoice",
    11: "Processed",
  }




  const sortedStages = (payoutStagesData || []).slice().sort((a, b) => {
    if (a.id === 0) return -1;
    if (b.id === 0) return 1;
    return 0;
  });

  const options = sortedStages.map((stage) => ({
    label: (
      <div
        style={{
          position: "relative",
          fontSize: "0.8rem",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {stage.name}
        <Badge
          shape="circle"
          count={stage.partnerCount}
          overflowCount={99999}
          showZero
          style={{ position: "absolute", top: -38, right: -27, zIndex: 1 }}
        />
      </div>
    ),
    value: handleStageMap[stage.id] || stage.name,
  }));







  const handleCheckboxChange = (e, column, rowId) => {
    const isChecked = e.target.checked;
    setSelectedCheckboxes((prevState) => {
      const newState = { ...prevState };
      if (isChecked) {
        newState[column] = [...newState[column], rowId];
      } else {
        newState[column] = newState[column].filter((item) => item !== rowId);
      }
      return newState;
    });
  };

  const options1 = [
    { label: "As of Month", value: "AsofMonth" },
    { label: "YTD", value: "YTD" },
  ];

  // Add this function
  const handlePageChange = async (page, pageSize, approvalStageId) => {

    // Call the API with the new page and pageSize
    const payoutPartnerResponse = await props.payoutPartnerDataSuccess({
      accessToken: props.accessToken,
      reportId: monthlyReportId,
      approvalStageId: approvalStageId,
      page: page - 1, // API is usually 0-indexed
      record: pageSize,
    });
    const res = payoutPartnerResponse;
    const errorCode = res?.response?.data?.error?.errorCode || res.errorCode;
    const errorMessage = res?.response?.data?.error?.errorMessage || res.errorMessage
    if (errorCode === "403" && (res?.response?.data?.error?.logoutStatus || res?.data?.error?.logoutStatus)) {
      // Handle logout status 
      handleSessionExpired();
      return;
    }
    // You can redirect to the login page or show a message 
    setLanDatasource(res.content || []);

    setPagination((prev) => ({
      ...prev,
      current: page,
      pageSize,
      total: res?.totalElements,
    }));
  };

  const handleQueryRemark = async () => {
    // const getpartnerIds = Object.keys(selectedCheckboxes.Check).length > 0 ? selectedCheckboxes.Check.map(item => item.partnerId) : [selectedPartnerId];
    // const parentIdq = queryPartnerId;
    // const queryData = {
    //   "partnerid": [parentIdq],
    //   "reportid": ReportId,
    //   "userId": props.userDetail?.userId,
    //   "stage": currentStage,
    //   "payoutid": [],
    //   "remarks": {
    //     "partnerId": parentIdq,
    //     "reportId": ReportId,
    //     "userId": props.userDetail?.userId,
    //     "remarksComment": remarkComment,
    //     "stage": 1,
    //     "remarkType": "InternalQuery"
    //   }
    // };

    const queryData = [
      ...multiQueryReamark.map((item) => ({
        partnerId: item.partnerId,
        // reportId: parseInt(monthlyReportId),
        reportId: monthlyReportId,
        userId: props.userDetail?.userId,
        remarksComment: item.Remark,
        stage: 1,
        remarkType: "InternalQuery"
      }))
    ];


    const resQuery = await props.RaiseQueryInternal({
      accessToken: props.accessToken,
      query: queryData
    });


    if (resQuery !== "Query Raised with success") {
      const res = resQuery || {};
      const errorCode = res?.response?.data?.error?.errorCode || res.errorCode || null;
      const errorMessage = res?.response?.data?.error?.errorMessage || res.errorMessage || "Unknown error";

      if (
        errorCode === "403" &&
        (res?.response?.data?.error?.logoutStatus || res?.data?.error?.logoutStatus)
      ) {
        handleSessionExpired();
        return;
      }

      // Optionally handle other errors
      if (!errorCode) {
        console.error("No errorCode found in response.");
      }
    }

    message.success("Query submitted successfully!");
    setMultiQueryRemark([]);
    await fetchPayoutStagesData(); // Refresh the stages data
    await fetchPaginatedData(currentStage, radiostate); // Refresh the data after submission

  }


  const fetchPaginatedData = async (approvalStageId, radioStateValue) => {
    setDownloading(true);
    try {
      let current = pagination.current || 1;
      let pageSize = pagination.pageSize || 10;
      const response = await props.payoutPartnerDataSuccess({
        accessToken: props.accessToken,
        reportId: monthlyReportId,
        approvalStageId,
        page: current - 1,
        record: pageSize,
      });
      const data = response.content || [];
      setPagination((prev) => ({
        ...prev,
        current,
        pageSize,
        total: response?.totalElements,
      }));
      setLanDatasource(data);
      setMakerAction(false);
      setCheckerAction(approvalStageId === 2 ? approvalStageId === 2 || radioStateValue === "PendingwithCETChecker" : approvalStageId === 8 ? approvalStageId === 8 || radioStateValue === "CETApprovalPendingonInvoice" : approvalStageId === 10 ? approvalStageId === 10 || radioStateValue === "CpApprovedInvoice" : false);
      setUtrAction(false);
      setSelectedCheckboxes({ Check: [] });
      setRadioState(radioStateValue);
      setCurrentStage(approvalStageId);
    }
    catch (error) {
      console.error("Error fetching paginated data:", error);
    } finally {
      setDownloading(false);
    }
  };

  const handleRadioChange = async (value, data = payoutDataWithPartner) => {
    switch (value) {
      case "All":

        fetchPaginatedData(0, "All");
        break;

      case "PendingwithCETMaker":

        fetchPaginatedData(1, "PendingwithCETMaker");
        break;

      case "PendingwithCETChecker":

        fetchPaginatedData(2, "PendingwithCETChecker");
        break;

      case "PendingwithCPChecker":

        fetchPaginatedData(3, "PendingwithCPChecker");
        break;

      case "CpApproved":

        fetchPaginatedData(4, "CpApproved");
        break;

      case "PendingwithPartner":

        fetchPaginatedData(5, "PendingwithPartner");
        break;

      case "PartnerQuery":

        fetchPaginatedData(6, "PartnerQuery");
        break;

      case "InvoiceUploaded":

        fetchPaginatedData(7, "InvoiceUploaded");
        break;

      case "CETApprovalPendingonInvoice":

        fetchPaginatedData(8, "CETApprovalPendingonInvoice");
        break;

      case "CpapprovalpendingonInvoice":

        fetchPaginatedData(9, "CpapprovalpendingonInvoice");
        break;

      case "CpApprovedInvoice":

        fetchPaginatedData(10, "CpApprovedInvoice");
        break;

      case "Processed":

        fetchPaginatedData(11, "Processed");
        break;

      case "AsofMonth":
        break;

      case "YTD":
        break;

      default:
        setMakerAction(false);
        setCheckerAction(false);
        setUtrAction(false);
        setCurrentStage(null);
        break;
    }
  };


  const handelCancleQuery = () => {
    setMultiQueryRemark([]);
  };


  //   const formatAmount = (amount) => {
  //   if (amount >= 10000000) { // 1 Crore
  //     return (amount / 10000000).toFixed(1).replace(/\.0$/, '') + 'Cr';
  //   } else if (amount >= 100000) { // 1 Lakh
  //     return (amount / 100000).toFixed(1).replace(/\.0$/, '') + 'L';
  //   } else if (amount >= 1000) { // 1 Thousand
  //     return (amount / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  //   } else {
  //     return amount.toString();
  //   }
  // };

  const getDynamicFontSize = (formattedAmount) => {
    const text = '₹' + formattedAmount;
    const length = text.length;

    if (length <= 6) return 18;
    else if (length <= 8) return 16;
    else if (length <= 12) return 14;
    else if (length <= 16) return 12;
    else return 10;
  };

  const debouncedSearch = useMemo(() =>
    debounce(async (value) => {
      const searchValue = String(value || "").trim().toLowerCase();

      if (!searchValue) {
        // Clear search - show all data
        message.info("Search cleared, showing all data.");
        setPagination(prev => ({
          ...prev,
          current: 1,
          pageSize: 10,
        }));
        await fetchPaginatedData(currentStage, radiostate);
        return;
      }

      try {
        // // Show loading state
        // setLoading?.(true);

        const response = await props.payoutPartnersearch({
          accessToken: props.accessToken,
          reportId: monthlyReportId,
          approvalStageId: currentStage,
          partner_name: searchValue,
        });

        const searchData = response || [];

        if (searchData && searchData.message) {
          if (searchData && searchData.response.data.data.errorMessage) {
            message.error(searchData.response.data.data.errorMessage);
          } else {
            message.error(searchData.message);
          }

          setSearchLanDatasource([]);
          setLanDatasource([]);
        } else {
          setSearchLanDatasource(searchData || []);
          setLanDatasource(searchData || []);
        }

        // setSearchLanDatasource(searchData);
        // setLanDatasource(searchData);


        setPagination(prev => ({
          ...prev,
          current: 1,
          total: searchData.length,
          pageSize: searchData.length > 0 ? searchData.length : 10,
        }));

        message.info(`Found ${searchData.length} results`);

      } catch (error) {
        console.error("Search error:", error);
        message.error("Search failed. Please try again.");



      } finally {
        // setLoading?.(false);
      }
    }, 300),
    [props.accessToken, monthlyReportId, currentStage, radiostate]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTextTable(value);
    debouncedSearch(value);
  };


  return (
    <div className="dashboardPayout" style={{ maxWidth: "100%" }}>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
          <Col md={8} className="search-bar">
            <Button
              type="default"
              style={{
                margin: "0",
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '2px', // space between icon and text
                padding: '0 8px',
                color: '#00b1b1',
              }}
              onClick={() => navigate(-1)}
            >
              <LeftCircleOutlined />
              <span>Back</span>
            </Button>
          </Col>
          <Col md={4}>
            <div className="login-profie">
              <div className="img-sec">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                    props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}

                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                    props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>

              <div className="content-login">
                <h4>{props.userDetail?.userName}</h4>
                <h5>{props.userDetail?.roleName}</h5>

                <div className="content-login-data">
                  {/* <ChangePassword /> */}
                  <div className="admin-small-space"> </div>

                  <Logout />
                  {/* <h6>Change Password | Logout</h6> */}
                </div>
              </div>
            </div>
          </Col>
        </Col>
      </Row>

      <Row>
        <div style={{ display: "flex" }}>
          <Col lg={4} xs={4} md={4} sm={4}>
            <Col
              md={6}
              style={{ display: "flex", margin: 10 }}
              className="btn-partner"
            >
              <div>
                {/* <Button
                  className="ant-btn ant-btn-default"
                  type="primary"
                  style={{ marginLeft: 5, width: 200, backgroundColor: '#1b8593', color: '#fff', fontSize: '0.9rem', padding: 10, borderRadius: '5px', border: 'none' }}
                >
                  Advance Search
                </Button> */}
              </div>
            </Col>
          </Col>

        </div>
      </Row>


      <Row>
        <Col>
          <div
            className="ant-card-container"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start", // Align cards from the left
              gap: "14px",
              width: "100%",
              paddingBottom: 18,

            }}
          >


            <Card
              style={{
                textAlign: "center",
                flex: "1 1 50px",
                minWidth: 60,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                padding: "8px 4px",
              }}
              title={
                <span style={{
                  fontSize: 12,
                  whiteSpace: "nowrap", // Prevent title from wrapping
                  overflow: "hidden",
                  display: "block"
                }}>
                  No of Partners
                </span>
              }
              variant="borderless"
            >
              <span style={{ fontWeight: "bold", fontSize: 18, color: "#1b8593", padding: 0 }}>
                {summaryData.totalPartner ?? 0}
              </span>
            </Card>
            <Card
              style={{
                textAlign: "center",
                flex: "1 1 50px",
                minWidth: 60,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                padding: "8px 4px",
                textAlign: "wrap"
              }}
              title={
                <span style={{
                  fontSize: 11,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  display: "block"
                }}>
                  1st Disb
                </span>
              }
              variant="borderless"
            >
              <span style={{
                fontWeight: "bold",
                fontSize: getDynamicFontSize(summaryData.totalFirstDisbAmount ?? 0),
                color: "#1b8593",
                padding: 0,
                display: "block",
                whiteSpace: "nowrap"
              }}>
                ₹{summaryData.totalFirstDisbAmount ?? 0}
              </span>
            </Card>
            <Card
              style={{
                textAlign: "center",
                flex: "1 1 50px",
                minWidth: 60,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                padding: "8px 4px",
              }}
              title={
                <span style={{
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  display: "block"
                }}>
                  Tranche Disb
                </span>
              }
              variant="borderless"
            >
              <span style={{ fontWeight: "bold", fontSize: getDynamicFontSize(summaryData.totalTrancheDisbAmount ?? 0), color: "#1b8593", padding: 0 }}>
                ₹{summaryData.totalTrancheDisbAmount ?? 0}
              </span>
            </Card>
            <Card
              style={{
                textAlign: "center",
                flex: "1 1 50px",
                minWidth: 60,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                padding: "8px 4px",
              }}
              title={
                <span style={{
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  display: "block"
                }}>
                  Disb Count
                </span>
              }
              variant="borderless"
            >
              <span style={{ fontWeight: "bold", fontSize: 18, color: "#1b8593", padding: 0 }}>
                {summaryData.disbursementCount ?? 0}
              </span>
            </Card>
            <Card
              style={{
                textAlign: "center",
                flex: "1 1 50px",
                minWidth: 60,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                padding: "8px 4px",
              }}
              title={
                <span style={{
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  display: "block"
                }}>
                  Hold Amt
                </span>
              }
              variant="borderless"
            >
              <span style={{ fontWeight: "bold", fontSize: getDynamicFontSize(summaryData.holdAmount ?? 0), color: "#1b8593", padding: 0 }}>
                ₹{summaryData.holdAmount ?? 0}
              </span>
            </Card>
            <Card
              style={{
                textAlign: "center",
                flex: "1 1 50px",
                minWidth: 60,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                padding: "8px 4px",
              }}
              title={
                <span style={{
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  display: "block"
                }}>
                  Recovery Amt
                </span>
              }
              variant="borderless"
            >
              <span style={{ fontWeight: "bold", fontSize: getDynamicFontSize(summaryData.recoveryAmount ?? 0), color: "#1b8593", padding: 0 }}>
                ₹{summaryData.recoveryAmount ?? 0}
              </span>
            </Card>
            <Card
              style={{
                textAlign: "center",
                flex: "1 1 50px",
                minWidth: 60,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                padding: "8px 4px",
              }}
              title={
                <span style={{
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  display: "block"
                }}>
                  Net Payout
                </span>
              }
              variant="borderless"
            >
              <span style={{ fontWeight: "bold", fontSize: getDynamicFontSize(summaryData.netAmount ?? 0), color: "#1b8593", padding: 0 }}>
                ₹{summaryData.netAmount ?? 0}
              </span>
            </Card>


          </div>
        </Col>
      </Row>


      {/* <Row>
        <div style={{ display: "flex", width: "100%", marginBottom: "20px" }}>
          <div className="buckets-container" style={{ width: "100%" }} >
            <Col md={8} style={{ width: "90%" }} className="radio-group-container">
              <Radio.Group
                block
                options={options}
                defaultValue="All"
                onChange={(e) => {
                  handleRadioChange(e.target.value);
                }}
                optionType="button"
                buttonStyle="solid"
                buttonCheckedBg="#1b8593"
              />
            </Col>
            <col md={4} style={{ width: "10%" }} className="radio-group-container">
            <button
              className="ant-btn ant-btn-default"
              >test</button>
            </col>
          </div>
       
        </div>
      </Row> */}

      <Row>
        <div style={{ display: "flex", width: "100%", marginBottom: "20px" }}>
          <div className="buckets-container" style={(currentStage === 2 && multiQueryReamark.length) ? { width: "70%" } : { width: "100%" }}>
            <Col
              md={8}
              style={{ width: "100%", marginRight: "16px" }}
              className="radio-group-container"
            >
              <Radio.Group
                options={options}
                defaultValue="All"
                onChange={(e) => handleRadioChange(e.target.value)}
                optionType="button"
                buttonStyle="solid"
              />
            </Col>
          </div>
          {currentStage === 2 && multiQueryReamark.length > 0 && (
            <div
              className="buckets-container"
              style={{ width: "30%", float: "right" }}
            >

              <Button
                className="ant-btn ant-btn-default"
                type="primary"
                style={{
                  background: "#1b8593",
                  color: "#fff",
                  borderRadius: "5px",
                  textDecoration: "none",
                  margin: "20px",
                  minWidth: "200px",
                  fontSize: "0.8rem",
                  padding: "10px 20px",
                }}
                onClick={() => handleQueryRemark()}
              >
                Submit {multiQueryReamark.length} Query
              </Button>

              <span style={{ color: "#1b8593", fontSize: "0.8rem" }}>
                <CloseCircleOutlined onClick={handelCancleQuery} />
              </span>

            </div>
          )}
        </div>
      </Row>

      <Row style={{ display: "flex", marginTop: 20 }}>
        <Col
          md={9}
          style={{
            display: "flex",
            justifyItems: "end",
            alignItems: "end",
            justifyContent: "end",
          }}
        ></Col>
        <Col
          md={3}
          style={{
            display: "flex",
            justifyItems: "end",
            alignItems: "end",
            justifyContent: "end",
          }}
        >
          <Input
            //  disabled={!searchlandatasource.length}
            className="search-input"
            allowClear
            placeholder="Search..."
            suffix={<SearchOutlined />}
            // prefix={
            //   searchTextTable && (
            //     <CloseOutlined
            //       onClick={clearSearch}
            //       style={{ cursor: "pointer" }}
            //     />
            //   )
            // }
            value={searchTextTable}
            onChange={handleSearch}
            style={{ width: 200 }}
          />
        </Col>
        <PartnerListWithPayoutChecker
          landataSource={landatasource}
          makerAction={makerAction}
          checkerAction={checkerAction}
          utrAction={utrAction}
          setMakerAction={setMakerAction}
          setCheckerAction={setCheckerAction}
          setUtrAction={setUtrAction}
          setLanDatasource={setLanDatasource}
          handleRadioChange={handleRadioChange}
          radiostate={radiostate}
          pagination={pagination}
          onPageChange={handlePageChange}
          setRadioState={setRadioState}
          handleCheckboxChange={handleCheckboxChange}
          selectedCheckboxes={selectedCheckboxes}
          setSelectedCheckboxes={setSelectedCheckboxes}
          ReportId={monthlyReportId}
          currentStage={currentStage}
          fetchPaginatedData={fetchPaginatedData}
          fetchPayoutStagesData={fetchPayoutStagesData}
          multiQueryReamark={multiQueryReamark}
          setMultiQueryRemark={setMultiQueryRemark}
          loading={downloading}
        />
      </Row>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    payoutApprovalStagesSuccess: (data) => dispatch(payoutApprovalStagesSuccess(data)),
    payoutPartnerDataSuccess: (data) => dispatch(payoutPartnerDataSuccess(data)),
    getMonthlySummary: (data) => dispatch(getMonthlySummarySuccess(data)),
    RaiseQueryInternal: (data) => dispatch(getPayoutQueryInternalActionv2(data)),
    payoutPartnersearch: (data) => dispatch(payoutPartnerDataSearch(data)),
  }
};

const mapStateToProps = (state) => {
  return {
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
    payoutApprovalStages: state.payoutApprovalStages.payoutApprovalStages,
    payoutPartnerData: state.payoutPartnerData.payoutPartnerData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerListDetailsChecker);
